module.exports = __webpack_public_path__ + "media/assets/icons/thumb_up-0038aeedcc1b88613eaa9bdf427f5ff1.svg";